const routes = [
    {
        name: 'fluxoCaixaParceiro',
        path: '/parceiro/financeiro/fluxo_caixa',
        alias: [
            '/parceiro/financeiro/fluxo_caixa/index',
            '/contabilidade/financeiro/fluxo_caixa',
            '/contabilidade/financeiro/fluxo_caixa/index',
        ],
        component: () => import('../views/FluxoCaixa'),
    },
    {
        name: 'fluxoCaixaVisualizaSaqueParceiro',
        path: '/parceiro/financeiro/visualizar_saque/:id',
        alias: [
            '/contabilidade/financeiro/visualizar_saque/:id'
        ],
        component: () => import('../views/Visualizar'),
    },
]

export default routes
